export default "__VITE_ASSET__DZgRsgTw__"